"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTemplate = void 0;
const ShapeSet_1 = require("lincd/lib/collections/ShapeSet");
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const irlcg_1 = require("../ontologies/irlcg");
const xsd_1 = require("lincd-xsd/lib/ontologies/xsd");
const Boolean_1 = require("lincd-xsd/lib/shapes/Boolean");
const XSDDate_1 = require("lincd-xsd/lib/shapes/XSDDate");
const Thing_1 = require("lincd-schema/lib/shapes/Thing");
const Resource_1 = require("./Resource");
const StepSet_1 = require("./StepSet");
const Form_1 = require("lincd-form/lib/shapes/Form");
let ActionTemplate = class ActionTemplate extends Thing_1.Thing {
    /**
     * instances of this shape need to have exactly one value defined for the given property
     */
    get estimatedTimeMin() {
        return parseInt(this.getValue(irlcg_1.irlcg.estimatedTimeMin));
    }
    set estimatedTimeMin(val) {
        this.overwrite(irlcg_1.irlcg.estimatedTimeMin, new models_1.Literal(val.toString(), xsd_1.xsd.duration));
    }
    get estimatedTimeMax() {
        return parseInt(this.getValue(irlcg_1.irlcg.estimatedTimeMax));
    }
    set estimatedTimeMax(val) {
        this.overwrite(irlcg_1.irlcg.estimatedTimeMax, new models_1.Literal(val.toString(), xsd_1.xsd.duration));
    }
    get priority() {
        return Boolean_1.Boolean.isTrue(this.getOne(irlcg_1.irlcg.priority));
    }
    set priority(val) {
        this.overwrite(irlcg_1.irlcg.priority, val ? Boolean_1.Boolean.true() : Boolean_1.Boolean.false());
    }
    get cycleDuration() {
        return parseInt(this.getValue(irlcg_1.irlcg.cycleDuration));
    }
    set cycleDuration(val) {
        this.overwrite(irlcg_1.irlcg.cycleDuration, new models_1.Literal(val.toString(), xsd_1.xsd.duration));
    }
    get cycleSetTime() {
        return this.getOneAs(irlcg_1.irlcg.cycleSetTime, XSDDate_1.XSDDate);
    }
    set cycleSetTime(val) {
        this.overwrite(irlcg_1.irlcg.cycleSetTime, val.node);
    }
    get timeDescription() {
        return this.getValue(irlcg_1.irlcg.timeDescription);
    }
    set timeDescription(val) {
        this.overwrite(irlcg_1.irlcg.timeDescription, new models_1.Literal(val, xsd_1.xsd.string));
    }
    get estimatedCost() {
        return parseInt(this.getValue(irlcg_1.irlcg.estimatedCost));
    }
    set estimatedCost(val) {
        this.overwrite(irlcg_1.irlcg.estimatedCost, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    get estimatedCo2Reduction() {
        return parseInt(this.getValue(irlcg_1.irlcg.estimatedCo2Reduction));
    }
    set estimatedCo2Reduction(val) {
        this.overwrite(irlcg_1.irlcg.estimatedCo2Reduction, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    get materials() {
        return Thing_1.Thing.getSetOf(this.getAll(irlcg_1.irlcg.material));
    }
    get resources() {
        return Resource_1.Resource.getSetOf(this.getAll(irlcg_1.irlcg.resource));
    }
    get steps() {
        return StepSet_1.StepSet.getSetOf(this.getAll(irlcg_1.irlcg.steps));
    }
    get reportingForms() {
        return Form_1.Form.getSetOf(this.getAll(irlcg_1.irlcg.reportingForm));
    }
    get points() {
        return parseInt(this.getValue(irlcg_1.irlcg.points));
    }
    set points(val) {
        this.overwrite(irlcg_1.irlcg.points, new models_1.Literal(val.toString(), xsd_1.xsd.integer));
    }
    get isBonus() {
        return Boolean_1.Boolean.isTrue(this.getOne(irlcg_1.irlcg.isBonus));
    }
    set isBonus(val) {
        this.overwrite(irlcg_1.irlcg.isBonus, val ? Boolean_1.Boolean.true() : Boolean_1.Boolean.false());
    }
    get isCustom() {
        return Boolean_1.Boolean.isTrue(this.getOne(irlcg_1.irlcg.isCustom));
    }
    set isCustom(val) {
        this.overwrite(irlcg_1.irlcg.isCustom, val ? Boolean_1.Boolean.true() : Boolean_1.Boolean.false());
    }
};
exports.ActionTemplate = ActionTemplate;
/**
 * indicates that instances of this shape need to have this rdf.type
 */
ActionTemplate.targetClass = irlcg_1.irlcg.ActionTemplate;
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.estimatedTimeMin,
        dataType: xsd_1.xsd.duration,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ActionTemplate.prototype, "estimatedTimeMin", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.estimatedTimeMax,
        dataType: xsd_1.xsd.duration,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ActionTemplate.prototype, "estimatedTimeMax", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.priority,
        dataType: Boolean_1.Boolean.targetClass,
        maxCount: 1,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ActionTemplate.prototype, "priority", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.cycleDuration,
        dataType: xsd_1.xsd.duration,
        maxCount: 1,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ActionTemplate.prototype, "cycleDuration", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.cycleSetTime,
    }),
    __metadata("design:type", XSDDate_1.XSDDate),
    __metadata("design:paramtypes", [XSDDate_1.XSDDate])
], ActionTemplate.prototype, "cycleSetTime", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.timeDescription,
        dataType: xsd_1.xsd.string,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], ActionTemplate.prototype, "timeDescription", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.estimatedCost,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ActionTemplate.prototype, "estimatedCost", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.estimatedCo2Reduction,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ActionTemplate.prototype, "estimatedCo2Reduction", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.material,
        shape: Thing_1.Thing,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], ActionTemplate.prototype, "materials", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.resource,
        shape: Resource_1.Resource,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], ActionTemplate.prototype, "resources", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.steps,
        shape: StepSet_1.StepSet,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], ActionTemplate.prototype, "steps", null);
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.reportingForm,
        shape: Form_1.Form,
    }),
    __metadata("design:type", ShapeSet_1.ShapeSet),
    __metadata("design:paramtypes", [])
], ActionTemplate.prototype, "reportingForms", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.points,
    }),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], ActionTemplate.prototype, "points", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.isBonus,
        dataType: Boolean_1.Boolean.targetClass,
        maxCount: 1,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ActionTemplate.prototype, "isBonus", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.isCustom,
        dataType: Boolean_1.Boolean.targetClass,
        maxCount: 1,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], ActionTemplate.prototype, "isCustom", null);
exports.ActionTemplate = ActionTemplate = __decorate([
    package_1.linkedShape
], ActionTemplate);
//# sourceMappingURL=ActionTemplate.js.map